<template>
  <v-row no-gutters>
    <v-col cols="2" />
    <v-col cols="8" class="pl-1 text-caption grey--text">
      * {{ name }}
    </v-col>
    <v-col cols="2" class="pl-2 text-caption grey--text text-right">
      -{{ amount | currency }}
    </v-col>
  </v-row>
</template>

<script>
  import Currenciable from '@/Mixins/Currenciable'
  import I18n from '@/Mixins/I18n'

  export default {
    mixins: [
      Currenciable,
      I18n,
    ],

    props: {
      discount: {
        required: true,
        type: Object,
      },
      amount: {
        required: true,
        type: Number,
      },
    },

    computed: {
      name () {
        return this.discount?.name ?? this.__('discount')
      },
    },
  }
</script>
